// jwt-like-token-linear-scan.ts — vòng sửa 3 redactor (review L5).
//
// Thay regex `/eyJ[A-Za-z0-9_-]{10,}\.[…]{5,}\.[…]{5,}/g`: trên một run dài
// chứa nhiều `eyJ` mà không có `.`, regex thử lại từ MỖI `eyJ` rồi lùi dần ⇒
// gần O(n²) (đo: `"eyJ".repeat(60000)` ≈ 9,8 s chặn event loop của
// supervisor) — nội dung do worker sinh nên kích được. Quét tay, tuyến tính,
// CÙNG ngữ nghĩa: đoạn 1 ≥ 10, đoạn 2 và 3 ≥ 5 ký tự `[A-Za-z0-9_-]`, nối bằng
// `.`. Mọi `eyJ` nằm trong cùng một run chia chung điểm kết thúc của các đoạn ⇒
// một `eyJ` thất bại thì mọi `eyJ` sau nó trong run cũng thất bại ⇒ nhảy qua run.
import type { MatchInterval } from "./secret-match-intervals.js";

const JWT_PREFIX = "eyJ";
const MIN_SEGMENT_LENGTHS = [10, 5, 5] as const;

function isSegmentChar(code: number): boolean {
  return (
    (code >= 48 && code <= 57) || // 0-9
    (code >= 65 && code <= 90) || // A-Z
    (code >= 97 && code <= 122) || // a-z
    code === 95 || // _
    code === 45 // -
  );
}

function segmentEnd(text: string, from: number): number {
  let i = from;
  while (i < text.length && isSegmentChar(text.charCodeAt(i))) i++;
  return i;
}

/**
 * Khoảng JWT-like; `finalize = false` bỏ khoảng chạm cuối text (có thể còn
 * đang tới — cùng luật `patternMatchIntervals`).
 */
export function jwtLikeMatchIntervals(text: string, finalize: boolean): MatchInterval[] {
  const out: MatchInterval[] = [];
  let i = text.indexOf(JWT_PREFIX);
  while (i !== -1) {
    const firstEnd = segmentEnd(text, i + JWT_PREFIX.length);
    let cursor = i + JWT_PREFIX.length;
    let end = -1;
    for (const [index, min] of MIN_SEGMENT_LENGTHS.entries()) {
      const segEnd = index === 0 ? firstEnd : segmentEnd(text, cursor);
      if (segEnd - cursor < min) break;
      if (index === MIN_SEGMENT_LENGTHS.length - 1) end = segEnd;
      else if (text[segEnd] !== ".") break;
      cursor = segEnd + 1;
    }
    if (end !== -1 && (finalize || end < text.length)) out.push([i, end]);
    i = text.indexOf(JWT_PREFIX, Math.max(end !== -1 ? end : firstEnd, i + 1));
  }
  return out;
}
